/* eslint-disable no-unused-vars */
import React from 'react';
import { Close } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dialog, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';

import { isMobile } from '../../../utils/mobile';
import WarningIcon from '../../../assets/images/Pricing/warning.png';

const CompletePetDialog = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const open = useSelector((state) => state.Modal.completePetDialog?.open);
  const { actualPet } = useSelector((state) => state.Animals) || {};

  const handleCloseDialog = () => {
    dispatch.Modal.setPetDialog({ open: false });
  };

  const handleConfirm = () => {
    handleCloseDialog();
    history.push(`/pet/edit/${actualPet?.id}`);
  };

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': {
        minWidth: '350px',
      },
      '& .MuiDialog-container': {
        height: 'auto',
        marginTop: isMobile ? '55px' : '150px',
      } }}
      fullScreen={isMobile}
      open={open}
      onBackdropClick={() => handleCloseDialog()}
    >
      <DialogTitle>
        <Grid container justifyContent='flex-end' alignItems='flex-end'>
          <Grid item>
            <Close sx={{ cursor: 'pointer' }} onClick={() => handleCloseDialog()} />
          </Grid>
        </Grid>
        <Grid container direction='column' justifyContent='center' alignItems='center' sx={{ marginTop: '34px' }} gap={2}>
          <Grid item>
            <img src={WarningIcon} alt='icon' />
          </Grid>

          <Grid item>
            <Typography sx={{ fontSize: '32px', lineHeight: '35px', fontWeight: 600, textAlign: 'center' }}>Complete os dados do seu pet</Typography>
          </Grid>

          <Grid item>
            <Typography sx={{ fontSize: '18px', lineHeight: '22px', fontWeight: 400, textAlign: 'center' }}>Para gerar a carteira de vacinação virtual, precisamos de algumas informações do seu pet</Typography>
          </Grid>

          <Grid item sx={{ marginTop: '68px' }}>
            <Button
              variant='large'
              sx={{ color: '#6B48FF' }}
              onClick={handleConfirm}
            >
              OK, VAMOS lÁ!
            </Button>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent />
    </Dialog>
  );
};

export default CompletePetDialog;
